module.exports = __webpack_public_path__ + "img/banano-bet-logo-yv_xmas.a5ffdfb0ba2203074fa4c5e633b5b824.svg";